import { Input } from '../../primitives';
import './productPreviewCarrousel.scss';

import React, { useEffect, useState } from 'react';

type ProductPreviewCarrouselProps = {
    carrouselMedias: React.ReactNode[];
};

export default function ProductPreviewCarrousel(
    props: ProductPreviewCarrouselProps
) {
    const { carrouselMedias } = props;
    const [sliderPosition, setSliderPosition] = useState(0);
    const [hasBeenClicked, setHasBeenClicked] = useState(false);
    const THREE_SECONDS_MS = 4000; //Wait 3 sec, change in the 4th

    useEffect(() => {
        const interval = setInterval(() => {
            if (!hasBeenClicked) {
                if (sliderPosition + 1 < carrouselMedias.length) {
                    setSliderPosition(sliderPosition + 1);
                } else setSliderPosition(0);
            }
        }, THREE_SECONDS_MS);

        return () => clearInterval(interval);
    }, [sliderPosition, carrouselMedias?.length]);

    return (
        <div className='product-preview-carrousel '>
            <div
                className='slide-container'
                onClick={() => setHasBeenClicked(true)}
            >
                <div className='blockSliderSingle'>
                    {carrouselMedias[sliderPosition]}
                </div>

                <div
                    className='slider-radios'
                    hidden={carrouselMedias?.length == 1}
                >
                    {carrouselMedias.map((_, index) => {
                        return (
                            <Input
                                className={`input ${index}`}
                                type='radio'
                                key={index}
                                id={`slider-radio${index}`}
                                value=''
                                error=''
                                checked={sliderPosition === index}
                                onChange={() => setSliderPosition(index)}
                                autocomplete=''
                                validateInput={() => {}}
                            />
                        );
                    })}
                </div>

                <div className='slider-arrows'>
                    <div
                        className='left-arrow option-prev option-nav'
                        onClick={() => {
                            if (sliderPosition - 1 >= 0) {
                                setSliderPosition(sliderPosition - 1);
                            } else
                                setSliderPosition(carrouselMedias.length - 1);
                        }}
                        hidden={carrouselMedias?.length == 1}
                    >
                        <span className='iconfont iconfont-prev' />
                    </div>
                    <div
                        className='right-arrow option-next option-nav'
                        onClick={() => {
                            if (sliderPosition + 1 < carrouselMedias.length) {
                                setSliderPosition(sliderPosition + 1);
                            } else setSliderPosition(0);
                        }}
                        hidden={carrouselMedias?.length == 1}
                    >
                        <span className='iconfont iconfont-next' />
                    </div>
                </div>
            </div>
        </div>
    );
}
